import HistoricalSentiment from 'zignal-widgets/lib/HistoricalSentiment';
import PopularPosts from 'zignal-widgets/lib/PopularPosts';
import PopularTweets from 'zignal-widgets/lib/PopularTweets';
import MediaQualityScoreOverTime from 'zignal-widgets/lib/MediaQualityScoreOverTime';
import TotalMentionsChartByIssue from 'zignal-widgets/lib/TotalMentionsChartByIssue';
import TotalMentions from 'zignal-widgets/lib/TotalMentions';
import SentimentBreakdown from 'zignal-widgets/lib/SentimentBreakdown';
import TrendingStories from 'zignal-widgets/lib/TrendingStories';
import PopularRedditPostsByComments from 'zignal-widgets/lib/PopularRedditPostsByComments';
import NetSentiment from 'zignal-widgets/lib/NetSentiment';
import TopStoriesByScore from 'zignal-widgets/lib/TopStoriesByScore';
import MediaBreakdown from 'zignal-widgets/lib/MediaBreakdown';
import ShareOfVoicePieChart from 'zignal-widgets/lib/ShareOfVoicePieChart';
import IssuesPieChart from 'zignal-widgets/lib/IssuesPieChart';
import ImpactScore from 'zignal-widgets/lib/ImpactScore';
import MediaScore from 'zignal-widgets/lib/MediaScore';
import TopSitesByMentions from 'zignal-widgets/lib/TopSitesByMentions';
import TopMediaBarChart from 'zignal-widgets/lib/TopMediaBarChart';
import TopSitesByShares from 'zignal-widgets/lib/TopSitesByShares';


export default {
  HistoricalSentiment,
  PopularPosts,
  PopularTweets,
  MediaQualityScoreOverTime,
  TotalMentionsChartByIssue,
  TotalMentions,
  SentimentBreakdown,
  TrendingStories,
  PopularRedditPostsByComments,
  NetSentiment,
  TopStoriesByScore,
  MediaBreakdown,
  ShareOfVoicePieChart,
  IssuesPieChart,
  ImpactScore,
  MediaScore,
  TopSitesByMentions,
  TopMediaBarChart,
  TopSitesByShares,
};
